<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="chart-dashboard">
  <div class="device-type-chart" [class.device-type-chart--compact]="isCompact">
    <div class="device-type-chart__header">
      <p class="chart-dashboard-title">{{ 'translations.analytics.deviceType.title' | transloco }}</p>
    </div>

    <div class="device-type-chart__bar">
      <div
        *ngFor="let stat of deviceStats"
        class="bar-segment"
        [class.bar-segment--mobile]="stat.type === DeviceType.MOBILE"
        [class.bar-segment--tablet]="stat.type === DeviceType.TABLET"
        [class.bar-segment--desktop]="stat.type === DeviceType.DESKTOP"
        [style.width.%]="stat.percentage"
        [matTooltip]="stat.type + ': ' + stat.percentage.toFixed(1) + '%'"
      ></div>
    </div>

    <div class="device-type-chart__legend">
      <div *ngFor="let stat of deviceStats" class="legend-item">
        <ng-container [ngSwitch]="stat.type">
          <ng-container *ngSwitchCase="DeviceType.MOBILE">
            <mat-icon class="legend-icon legend-icon--mobile">smartphone</mat-icon>
            <span class="legend-label">{{ 'translations.analytics.deviceType.mobile' | transloco }}</span>
            <span class="legend-percentage">{{ stat.percentage | number: '1.1-1' }}%</span>
          </ng-container>

          <ng-container *ngSwitchCase="DeviceType.TABLET">
            <mat-icon class="legend-icon legend-icon--tablet">tablet</mat-icon>
            <span class="legend-label">{{ 'translations.analytics.deviceType.tablet' | transloco }}</span>
            <span class="legend-percentage">{{ stat.percentage | number: '1.1-1' }}%</span>
          </ng-container>

          <ng-container *ngSwitchCase="DeviceType.DESKTOP">
            <mat-icon class="legend-icon legend-icon--desktop">computer</mat-icon>
            <span class="legend-label">{{ 'translations.analytics.deviceType.desktop' | transloco }}</span>
            <span class="legend-percentage">{{ stat.percentage | number: '1.1-1' }}%</span>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
